import React from 'react';
import './App.css';
import {Outlet, RouterProvider} from "react-router-dom";
import router from './router/appRouter';
import {AppContextProvider} from './contexts/appContext/app.context';
import store from "./store/store";
import {Provider} from "react-redux";

function App() {
    return (
        <Provider store={store}>
            <AppContextProvider>
                <div className="app-wrapper">
                    <RouterProvider router={router}/>
                    <Outlet/>
                </div>
            </AppContextProvider>
        </Provider>
    );
}

export default App;
